/*
 * Announcement bar carousel — plain (non-module) script.
 * Matches the .ab / [data-announcement-bar] / [data-ab-track] / [data-ab-slide] markup
 * in sections/header-announcements.liquid. Loaded via {{ 'announcement-bar.js' | asset_url | script_tag }}.
 */
(function () {
  function initBar(bar) {
    if (bar.__abInit) return;
    bar.__abInit = true;

    var track = bar.querySelector('[data-ab-track]');
    var slides = bar.querySelectorAll('[data-ab-slide]');
    if (!track || slides.length === 0) return;

    var count = slides.length;
    var index = 0;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
    var autoplay = bar.getAttribute('data-autoplay') === 'true' && count > 1;
    var timer = null;

    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      for (var i = 0; i < slides.length; i++) {
        slides[i].setAttribute('aria-hidden', i === index ? 'false' : 'true');
      }
    }
    function go(i) { index = ((i % count) + count) % count; render(); }
    function next() { go(index + 1); }
    function prev() { go(index - 1); }
    function start() { if (autoplay) { stop(); timer = setInterval(next, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var prevBtn = bar.querySelector('.ab__arrow--prev');
    var nextBtn = bar.querySelector('.ab__arrow--next');

    if (count <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    } else {
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    }

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    render();
    start();
  }

  function initAll() {
    var bars = document.querySelectorAll('[data-announcement-bar]');
    for (var i = 0; i < bars.length; i++) initBar(bars[i]);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  // Re-init when a section is reloaded in the theme editor
  document.addEventListener('shopify:section:load', initAll);
})();
